
// sticky header js

document.addEventListener("scroll", function () {
  const stickyHeader = document.querySelector(".itg_sticky_header_wrapper");
  
  if (window.scrollY > 200) { 
    stickyHeader?.classList.add("show");
  } else {
    stickyHeader?.classList.remove("show");
  }
});

document.querySelectorAll('.itg_sticky_header_wrapper .sticky_menu_contents').forEach(function(icon) {
    icon.addEventListener('mouseenter', function() {
        this.closest('.itg_sticky_header_inner_container').classList.add('active');
    });

    icon.addEventListener('mouseleave', function() {
        this.closest('.itg_sticky_header_inner_container').classList.remove('active');
    });
});

// sticky header js

// mobile nav menu drawer 


document.addEventListener("DOMContentLoaded", function() {
  // Open menu
  document.querySelector(".header-icons .itg_header_icons.mobile_menu_burger")
    .addEventListener("click", function(e) {
      let menuWrapper = e.target.closest(".itg_custom_header-menu");
      if (menuWrapper) {
        let innerMenu = menuWrapper.querySelector(".header-menu__inner");
        if (innerMenu) {
          innerMenu.classList.add("active");
          document.querySelector(".itg_header_inner_container").classList.add("hide_overflow");
        }
      }
    });

  // Close menu
  document.querySelectorAll(".header-menu__inner .mobile_drawer_cross_icon")
    .forEach(function(closeBtn) {
      closeBtn.addEventListener("click", function(e) {
        let innerMenu = e.target.closest(".header-menu__inner");
        if (innerMenu) {
          innerMenu.classList.remove("active");
          document.querySelector(".itg_header_inner_container").classList.remove("hide_overflow");
        }
      });
    });
});

// scroll trigger section

  document.addEventListener('DOMContentLoaded', () => {
      const sections = document.querySelectorAll('.scroll-trigger-section'); // Add this class to all target sections

      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  entry.target.classList.add('active_trigger'); // Add class when 50% visible
              } 
          });
      }, {
          root: null,
          threshold: 0.1 // Trigger when 50% of the section is visible
      });

      sections.forEach(section => observer.observe(section));
  });


  // lazy loading video


  document.addEventListener("DOMContentLoaded", function () {
  const lazyVideos = document.querySelectorAll("video.lazy-video");
 
  if ("IntersectionObserver" in window) {
    const videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
 
          const sources = video.querySelectorAll("source[data-src]");
          sources.forEach(source => {
            source.src = source.dataset.src;
            source.removeAttribute("data-src");
          });
 
          video.load();
          // video.play();  
 
          observer.unobserve(video);
        }
      });
    }, { threshold: 0.5 });
 
    lazyVideos.forEach(video => {
      videoObserver.observe(video);
    });
  }
});


// audio icon functionality on the video 


document.addEventListener("DOMContentLoaded", () => {

  const videoBlocks = document.querySelectorAll(".itg_video_block_wrapper");

  videoBlocks.forEach(block => {
    const video = block.querySelector("video");
    const audioIcon = block.querySelector(".audio_icon_wrapper");

    if (video && audioIcon) {
      audioIcon.addEventListener("click", () => {
        // Toggle active class
        audioIcon.classList.toggle("active");

        // Toggle mute state
        if (video.muted) {
           video.muted = false;
        } else {
          video.muted = true;
        }
      });
    }
  });
});

//  sticky product header js
  

// Observer and add to cart for product sticky header js


document.addEventListener("DOMContentLoaded", function () {

    const stickyHeaderSelector = '.sticky-product-header';
    const triggerSelector = '.itg_product_details_wrapper';
    const addToCartButtonSelector = '.sticky_product_header_addtoCart_btn';
    const activeClass = 'is-visible';

    const stickyHeader = document.querySelector(stickyHeaderSelector);
    const triggerElement = document.querySelector(triggerSelector);
    const addToCartBtn = stickyHeader?.querySelector(addToCartButtonSelector);

    if (!stickyHeader || !triggerElement) return;

    const toggleHiddenAtTop = () => {
      if (window.scrollY === 0) {
        // Always hide when at very top
        stickyHeader.classList.remove(activeClass);
        return true;
      }
      return false;
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // If user is at very top, make sure header is hidden
          if (toggleHiddenAtTop()) return;

          // If trigger is intersecting viewport => hide header
          if (entry.isIntersecting) {
            stickyHeader.classList.remove(activeClass);
          } else {
            // Trigger left the viewport (we scrolled past it) => show header
            stickyHeader.classList.add(activeClass);
          }
        });
      },
      {
        root: null,
        threshold: 0,
        // Adjust rootMargin to tweak when the header appears.
        // Example below triggers when the bottom of the trigger leaves viewport.
        rootMargin: '0px 0px -100% 0px',
      }
    );

    observer.observe(triggerElement);

    // Extra guard: some browsers/edge cases may not fire observer immediately on page load.
    // This scroll listener ensures the top-of-page check always hides header when scrollY === 0.
    window.addEventListener('scroll', () => {
      // If user is at the top, ensure header is hidden
      if (window.scrollY === 0) {
        stickyHeader.classList.remove(activeClass);
      }
    });


  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", async function (event) {
      
      event.preventDefault();
      const button = event.target;
      if (!button || button.disabled) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = "Adding...";

      try {
        let variantId = null;

        const productForm = document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
          const variantInput = productForm.querySelector('input[name="id"]');
          if (variantInput) variantId = variantInput.value;
        }

        if (!variantId && window.product && window.product.variants && window.product.variants.length > 0) {
          variantId = window.product.variants[0].id;
        }

        if (!variantId) {
          const productData = document.querySelector('[data-product-json]');
          if (productData) {
            const product = JSON.parse(productData.textContent);
            variantId = product.variants[0].id;
          }
        }

        if (!variantId) throw new Error("No variant selected");

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!response.ok) throw new Error("Failed to add to cart");

        button.textContent = "Added!";
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);

        document.dispatchEvent(new CustomEvent("cart:refresh"));

      } catch (error) {
        console.error("Error adding to cart:", error);
        button.textContent = "Error";
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      }
    });
  }
});


// Observer and add to cart for product sticky header js

//  sticky product header js


// new code

document.addEventListener('DOMContentLoaded', function() {
  const variantButtons = document.querySelectorAll('.product_options_wrapper .variant-option__button-label');
  const notifyButton = document.querySelector('.notify_me_custom_btn_itg');
  
  if (!variantButtons.length || !notifyButton) return;

  // Function to check availability
  function checkVariantAvailability() {
    const selectedInput = document.querySelector('.product_options_wrapper input[type="radio"]:checked');
    if (!selectedInput) return;

    const isAvailable = selectedInput.getAttribute('data-option-available') === 'true';

    if (!isAvailable) {
      notifyButton.style.display = 'block';
    } else {
      notifyButton.style.display = 'none';
    }
  }

  // Event: Variant option clicked
  variantButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      // Delay of 1.5 seconds after clicking a variant
      setTimeout(checkVariantAvailability, 1500);
    });
  });

  // Event: Page load (run after 1.5 seconds)
  setTimeout(checkVariantAvailability, 1500);
});

document.addEventListener("click", function (e) {
     
    // Check if the clicked element is the add-to-cart button
    const addToCartBtn = e.target.closest('.add-to-cart-button[name="add"][ref="addToCartButton"]');

    if (addToCartBtn) {

        // Check if its parent is inside #quick-add-modal-content
        const isInsideQuickModal = addToCartBtn.closest('#quick-add-modal-content');

        if (isInsideQuickModal) {

            // Prevent default click behavior

            // Wait 2 seconds
            setTimeout(() => {

                // Check body class
                if (document.body.classList.contains("upcartPopupShow")) {
                }
                    // Find close button inside modal and trigger click
                    const closeBtn = document.querySelector('.itg_quick_modal_wrapper [ref="closeButton"]');

                    if (closeBtn) {
                        closeBtn.click();
                    }
                     const openCartBtn_ = document.querySelector('.itg_header_icons[href="/cart"]');
                    if (openCartBtn_) {
                        openCartBtn_.click();
                    }
            }, 100);
        }
    }
});


// Image Lazy load js

document.addEventListener("DOMContentLoaded", () => {
  const lazyImages = document.querySelectorAll('img[data-src]');

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        obs.unobserve(img);
      }
    });
  });

  lazyImages.forEach(img => observer.observe(img));
});

